// extracted by mini-css-extract-plugin
export default {"selectedLanguage":"styles_selectedLanguage__buqJm"};